import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, mb, mh, onDesktop, p, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {ApplicationBox} from "../../application/components/ApplicationBox";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {IOfferDetail} from "../types/IOfferDetail";
import {getOfferDisplayStatus} from "../utils/get_offer_display_status";

type IProps = {
    offer: Pick<IOfferDetail, "id" | "vendor" | "is_phone_clip_enabled" | "sales_offices" | "name" | "status"> & {
        configuration: Pick<IOfferDetail["configuration"], "is_autoresponder_enabled" | "phone_clip" | "display_type" | "limited_presentation">;
    };
};

export const OfferDetailPreSaleForm = ({offer}: IProps) => {
    const theme = useTheme();
    const {isMobile} = useUserDevice();

    const gtmData: IGTMEventLeadForm = {
        clickText: InquiryButtonTypeName.OFFER,
        source: GTMEventApplicationSourceSection.TILE,
        vendorName: offer.vendor.name ?? offer.vendor.id.toString(),
        offerName: offer.name ?? offer.id.toString()
    };

    return (
        <div css={wrapperStyle}>
            <div css={contentStyle}>
                <Text as="h3" variant="headline_2" align="center" css={[mb(3)]}>
                    Zarezerwuj najlepsze mieszkanie w tej inwestycji
                </Text>

                <Text as="div" variant="body_copy_0" align="center" color={theme.colors.gray[800]} css={[mb(4)]}>
                    Możesz być jedną z pierwszych osób, która zarezerwuje mieszkanie z szerokiej puli dostępnych nieruchomości. Nie zwlekaj i zapytaj dewelopera
                    o więcej informacji na temat tej inwestycji.
                </Text>

                <div css={formWrapperStyle}>
                    <ApplicationBox
                        officeData={offer.sales_offices[0]}
                        storeHash="offerDetailSide"
                        source={ApplicationSource.PreSaleOffer}
                        sourceSection={ApplicationSourceSection.BODY}
                        vendorId={offer.vendor.id}
                        offerId={offer.id}
                        offerStatusStatus={offer?.status?.status}
                        optionalOfferPhoneData={offer}
                        optionalVendorInfoData={offer.vendor}
                        isAutoresponderEnabled={offer.configuration.is_autoresponder_enabled}
                        forceClose={getOfferDisplayStatus(offer) === "limited"}
                        disableVendorInfo={!!isMobile}
                        formButtonText="Zapytaj o ofertę"
                        render={
                            isMobile
                                ? ({openModal}) => (
                                      <Button variant="filled_primary" onClick={() => openModal(gtmData)} css={w100}>
                                          Zapytaj o ofertę
                                      </Button>
                                  )
                                : undefined
                        }
                        css={applicationBoxStyle}
                    />
                </div>
            </div>
        </div>
    );
};

const wrapperStyle = css`
    ${borderRadius()};
    background-color: #fff;
    ${p(3)};

    ${onDesktop(p(4))};
`;

const contentStyle = css`
    ${mh("auto")};
    max-width: 75rem;
`;

const formWrapperStyle = css`
    ${mh("auto")};
    width: 100%;
    max-width: 55rem;
`;

const applicationBoxStyle = (theme: Theme) => css`
    box-shadow: none;

    ${onDesktop(css`
        border: 1px solid ${theme.colors.gray[300]};
    `)};
`;
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {borderRadius, mb, mh, onDesktop, p, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {ApplicationBox} from "../../application/components/ApplicationBox";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {IOfferDetail} from "../types/IOfferDetail";
import {getOfferDisplayStatus} from "../utils/get_offer_display_status";

type IProps = {
    offer: Pick<IOfferDetail, "id" | "vendor" | "is_phone_clip_enabled" | "sales_offices" | "name" | "status"> & {
        configuration: Pick<IOfferDetail["configuration"], "is_autoresponder_enabled" | "phone_clip" | "display_type" | "limited_presentation">;
    };
};

export const OfferDetailPreSaleForm = ({offer}: IProps) => {
    const theme = useTheme();
    const {isMobile} = useUserDevice();

    const gtmData: IGTMEventLeadForm = {
        clickText: InquiryButtonTypeName.OFFER,
        source: GTMEventApplicationSourceSection.TILE,
        vendorName: offer.vendor.name ?? offer.vendor.id.toString(),
        offerName: offer.name ?? offer.id.toString()
    };

    return (
        <div css={wrapperStyle}>
            <div css={contentStyle}>
                <Text as="h3" variant="headline_2" align="center" css={[mb(3)]}>
                    Zarezerwuj najlepsze mieszkanie w tej inwestycji
                </Text>

                <Text as="div" variant="body_copy_0" align="center" color={theme.colors.gray[800]} css={[mb(4)]}>
                    Możesz być jedną z pierwszych osób, która zarezerwuje mieszkanie z szerokiej puli dostępnych nieruchomości. Nie zwlekaj i zapytaj dewelopera
                    o więcej informacji na temat tej inwestycji.
                </Text>

                <div css={formWrapperStyle}>
                    <ApplicationBox
                        officeData={offer.sales_offices[0]}
                        storeHash="offerDetailSide"
                        source={ApplicationSource.PreSaleOffer}
                        sourceSection={ApplicationSourceSection.BODY}
                        vendorId={offer.vendor.id}
                        offerId={offer.id}
                        offerStatusStatus={offer?.status?.status}
                        optionalOfferPhoneData={offer}
                        optionalVendorInfoData={offer.vendor}
                        isAutoresponderEnabled={offer.configuration.is_autoresponder_enabled}
                        forceClose={getOfferDisplayStatus(offer) === "limited"}
                        disableVendorInfo={!!isMobile}
                        formButtonText="Zapytaj o ofertę"
                        render={
                            isMobile
                                ? ({openModal}) => (
                                      <Button variant="filled_primary" onClick={() => openModal(gtmData)} css={w100}>
                                          Zapytaj o ofertę
                                      </Button>
                                  )
                                : undefined
                        }
                        css={applicationBoxStyle}
                    />
                </div>
            </div>
        </div>
    );
};

const wrapperStyle = css`
    ${borderRadius()};
    background-color: #fff;
    ${p(3)};

    ${onDesktop(p(4))};
`;

const contentStyle = css`
    ${mh("auto")};
    max-width: 75rem;
`;

const formWrapperStyle = css`
    ${mh("auto")};
    width: 100%;
    max-width: 55rem;
`;

const applicationBoxStyle = (theme: Theme) => css`
    box-shadow: none;

    ${onDesktop(css`
        border: 1px solid ${theme.colors.gray[300]};
    `)};
`;
